import axios from "axios";
import { useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";
import { getLanguageCode } from "../../utils/getURLParams";

export default function ATDTermsAndPrivacy( { nodeId }) {
  const [bodyText, setBodyText] = useState("");
  const { t } = useTranslation("common");

  useEffect(() => {
    const getTerms = async (nodeId) => {
      try {
        await axios
          .get(`/${getLanguageCode("Atd")}/api/${nodeId}`)
          .then((result) => {
            const data = result.data.intro[0].value;
            setBodyText(data);
          });
      } catch (err) {
        const errorMsg = `<p>${t('fetch-error-msg')} <br/> ${t('please-try-again-later')}</p>`
        setBodyText(errorMsg)
        console.error(`Couldn't fetch data: ${err}`);
      }
    };
    getTerms(nodeId);
  }, [nodeId, t]);

  return (
    <>
    {ReactHtmlParser(bodyText)}
    </>
  );
}
